import { useState, useEffect } from "react"
import { createPortal } from "react-dom"
import { useSearchParams } from "react-router-dom"
import Button from "../../../components/ui/Button"
import Topic from "./Topic"
import TopicIdeas from "./TopicIdeas"
import SavedIdeas from "./SavedIdeas"

const TopicIdeasMain = ({ onGenerateDocFromTopic }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [page, setPage] = useState("SavedIdeas")
  const [paymentSuccessOpen, setPaymentSuccessOpen] = useState(false)
  const [selectedTopicId, setSelectedTopicId] = useState(null)
  const [selectedTopicPreview, setSelectedTopicPreview] = useState(null)
  const [topicBackPage, setTopicBackPage] = useState("SavedIdeas")

  useEffect(() => {
    const paymentSuccess = searchParams.get("paymentSuccess") === "1"
    if (!paymentSuccess) return

    setPaymentSuccessOpen(true)
    setPage("TopicIdeas")

    const next = new URLSearchParams(searchParams)
    next.delete("paymentSuccess")
    setSearchParams(next, { replace: true })
  }, [searchParams, setSearchParams])

  const handleViewTopic = (topic, { fromPage = "SavedIdeas" } = {}) => {
    if (fromPage === "TopicIdeas") {
      setSelectedTopicId(null)
      setSelectedTopicPreview(topic)
    } else {
      setSelectedTopicId(topic._id)
      setSelectedTopicPreview(null)
    }
    setTopicBackPage(fromPage)
    setPage("Topic")
  }

  return (
    <>
      {paymentSuccessOpen &&
        createPortal(
          <dialog
            open
            className="modal fixed inset-0 z-[1100] items-start justify-center pt-6 sm:pt-10"
            aria-labelledby="topic-payment-success-title"
            aria-modal="true"
          >
            <div className="modal-box max-w-lg border border-emerald-200/70 bg-white text-slate-900 shadow-2xl">
              <div className="flex items-start gap-3">
                <div className="mt-0.5 flex h-10 w-10 items-center justify-center rounded-2xl bg-emerald-50 ring-1 ring-emerald-200/70">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-emerald-700" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
                  </svg>
                </div>
                <div className="min-w-0">
                  <h3 id="topic-payment-success-title" className="text-lg font-bold tracking-tight">
                    Payment successful
                  </h3>
                  <p className="mt-1 text-sm text-slate-600 leading-relaxed">
                    You can now generate topic ideas.
                  </p>
                </div>
              </div>

              <div className="mt-5 flex flex-col sm:flex-row gap-2 sm:justify-end">
                <Button onClick={() => setPaymentSuccessOpen(false)}>
                  Got it
                </Button>
              </div>
            </div>
            <form method="dialog" className="modal-backdrop" onClick={() => setPaymentSuccessOpen(false)}><button>close</button></form>
          </dialog>,
          document.body
        )}

      {page === "Topic" ? (
        <Topic
          setPage={setPage}
          topicId={selectedTopicId}
          topicPreview={selectedTopicPreview}
          backPage={topicBackPage}
          onGenerateDocFromTopic={onGenerateDocFromTopic}
        />
      ) : page === "SavedIdeas" ? (
        <SavedIdeas
          setPage={setPage}
          onViewTopic={handleViewTopic}
          onGenerateDocFromTopic={onGenerateDocFromTopic}
        />
      ) : (
        <TopicIdeas setPage={setPage} page={page} />
      )}
    </>
  )
}

export default TopicIdeasMain